module.exports = __webpack_public_path__ + "static/img/检测-act.7cb7e72f.png";